import * as React from "react";
import { MessageBar, MessageBarBody, Button } from "@fluentui/react-components";

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  React.PropsWithChildren<object>,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[ErrorBoundary] Uncaught error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16 }}>
          <MessageBar intent="error">
            <MessageBarBody>
              Something went wrong. Please reload the add-in.
            </MessageBarBody>
          </MessageBar>
          <Button
            appearance="primary"
            onClick={() => window.location.reload()}
            style={{ marginTop: 8 }}
          >
            Reload
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
